import { DATASET_VARIABLE_PATTERN } from "./customDatasetVariable";

/**
 * Normalises a dataset.variable value to uppercase when it is in the supported format.
 *
 * @param value - Candidate dataset.variable value entered by the user.
 * @returns The normalised uppercase dataset.variable value, or null when the format is invalid.
 */
export const normaliseDatasetVariable = (value: string): string | null => {
  const trimmedValue = value.trim();
  const match = DATASET_VARIABLE_PATTERN.exec(trimmedValue);
  return match ? `${match[1].toUpperCase()}.${match[2].toUpperCase()}` : null;
};
